import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CalendarWireframes from './CalendarWireframes';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Home from './pages/Home';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<CalendarWireframes />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/home" element={<Home />} />
    </Routes>
  );
}
